import { useSelector } from "react-redux";

const usePartners = () => {
    const partners = useSelector((state) => state.partners);
    return partners;
};

export default usePartners;